export default __webpack_public_path__ + "4f471ea12ba4c70edc27ed96be0b44c9.svg";